import { format as formatDateFns } from 'date-fns';

import { DateRangeValueType } from 'types';

export const dateObjToRangeValue = (
  date: Date | null,
  format: string,
): DateRangeValueType => (date ? formatDateFns(date, format) : null);
